import { createSelector } from 'reselect';
import _get from 'lodash/get';

import { getActivityTypesWithArchived } from 'lib/selectors/getActivityTypes';
import { ACTIVITY_MODES } from 'lib/constants';

const defaultRefs = [];

const getProductionActivityTypeRefs = createSelector(
  [getActivityTypesWithArchived],
  (activityTypes = []) => {
    if (!_get(activityTypes, 'length')) {
      return defaultRefs;
    }
    return activityTypes.reduce(
      (productionActivityTypeRefs, { activityMode, activityTypeRef }) => {
        if (activityMode === ACTIVITY_MODES.PRODUCTION) {
          return [...productionActivityTypeRefs, activityTypeRef];
        }
        return productionActivityTypeRefs;
      },
      []
    );
  }
);

export { getProductionActivityTypeRefs };
